"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAxiosError = exports.isError = void 0;
function isError(e) {
    var _a;
    return ((_a = e) === null || _a === void 0 ? void 0 : _a.message) !== undefined;
}
exports.isError = isError;
function isAxiosError(e) {
    var _a, _b;
    return ((_b = (_a = e) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) !== undefined;
}
exports.isAxiosError = isAxiosError;
//# sourceMappingURL=error.types.js.map